module.exports = __webpack_public_path__ + "static/img/logos_220px_aixinlife.6230b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/cooperation/img/finance/logos_220px_aixinlife.png
// module id = F47g
// module chunks = 0